var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLooolSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 12,
    viewBox: "0 0 66 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.01611,0A6,6,0,1,0,22,5.98392,6.01043,6.01043,0,0,0,16.01611,0Zm-.00806,10.125a4.125,4.125,0,1,1,4.117-4.133A4.13174,4.13174,0,0,1,16.00805,10.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.01611,0A6,6,0,1,0,36,5.98392,6.01043,6.01043,0,0,0,30.01611,0Zm-.008,10.125A4.125,4.125,0,1,1,34.125,5.992,4.13177,4.13177,0,0,1,30.00807,10.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.01608,0A6,6,0,1,0,50,5.98392,6.01042,6.01042,0,0,0,44.01608,0Zm-.008,10.125a4.125,4.125,0,1,1,4.117-4.133A4.13177,4.13177,0,0,1,44.008,10.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60 8.063 58.125 8.063 58.125 9.938 55.125 9.938 55.125 2.063 56.25 2.063 56.25 0.188 52.125 0.188 52.125 2.063 53.25 2.063 53.25 9.938 52.125 9.938 52.125 11.813 60 11.813 60 8.063",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.875 8.063 6 8.063 6 9.938 3 9.938 3 2.063 4.125 2.063 4.125 0.188 0 0.188 0 2.063 1.125 2.063 1.125 9.938 0 9.938 0 11.813 7.875 11.813 7.875 8.063",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66,3a3,3,0,1,1-3-3A2.99938,2.99938,0,0,1,66,3Zm-.45,0a2.55,2.55,0,1,0-2.54435,2.55A2.53414,2.53414,0,0,0,65.55,3Zm-2.11141.33559.71863.89848c.04278.058.02567.11593-.05133.11593h-.35931a.105.105,0,0,1-.09411-.058l-.73574-.93711h-.52186v.90813a.08208.08208,0,0,1-.077.08695H62.027a.08208.08208,0,0,1-.077-.08695V1.587a.08208.08208,0,0,1,.077-.087h1.16349A.891.891,0,0,1,64.2,2.43712.84153.84153,0,0,1,63.43859,3.33559Zm.3251-.89847c0-.28017-.1711-.46373-.56464-.46373h-.80418v.9178h.80418C63.59259,2.89119,63.76369,2.67864,63.76369,2.43712Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLooolSmall);
export default __webpack_public_path__ + "static/media/logo-loool-small.fd3167f9.svg";
export { ForwardRef as ReactComponent };